import ExternalLink from "@/components/ExternalLink";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { handleCompanyName } from "@/lib/handleName";
import { AssessmentProgress } from "@/schema/AssessmentProgress";
import ConfirmAssessmentDialog from "@/src/console/(auth)/(confirm-assessments)/assessments/_components/ConfirmAssessmentDialog";
import useAssessmentDialog from "@/src/console/(auth)/(confirm-assessments)/assessments/_hooks/useAssessmentDialog";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface AssessmentTableProps {
  data: AssessmentProgress[];
  isLoading: boolean;
}

function AssessmentTable({ data, isLoading }: AssessmentTableProps) {
  const { t } = useTranslation();
  const { setDialog } = useAssessmentDialog();

  const [confirmOpen, setConfirmOpen] = useState(false);
  const selectedProgress = useRef<AssessmentProgress | null>(null);

  const handleConfirmClick = (assessmentProgress: AssessmentProgress) => {
    selectedProgress.current = assessmentProgress;
    setConfirmOpen(true);
  };

  return (
    <>
      <SimpleTable
        isLoading={isLoading}
        data={data}
        columns={[
          {
            key: "name",
            label: t("name"),
            render: ({ id, company_name }) => (
              <div className="flex h-[42px] items-center">
                <span>{handleCompanyName(id, company_name)}</span>
              </div>
            ),
          },
          {
            key: "score",
            label: t("score"),
            render: ({ score }) => (
              <div className="flex h-[42px] items-center">
                <span>{score ?? "--"}</span>
              </div>
            ),
          },
          {
            key: "action-assessment-report",
            label: "",
            render: ({ id }) => (
              <ExternalLink
                label={t("assessment-report")}
                url={`/console/assessment-results/${id}?isFirstTime=true`}
              />
            ),
          },
          {
            key: "action-improvement-proposal",
            label: "",
            render: ({ id, has_improvement_proposal }) => (
              <>
                {has_improvement_proposal ? (
                  <ExternalLink
                    label={t("improvement-proposal")}
                    url={`/console/improvement-proposals/${id}`}
                  />
                ) : (
                  "No improvement proposal"
                )}
              </>
            ),
          },
          {
            width: "200px",
            key: "action-confirm",
            label: "",
            render: (assessmentProgress) => (
              <Button
                onClick={() => {
                  setDialog({
                    type: "confirm",
                    assessment: assessmentProgress,
                  });
                }}
                variant="outline"
              >
                {t("finalize-assessment")}
              </Button>
            ),
          },
        ]}
      />

      <ConfirmAssessmentDialog />
    </>
  );
}

export default AssessmentTable;
